module.exports = __webpack_public_path__ + "img/urology.63efe54a.png";